<div style="display: flex">
    <h3 mat-dialog-title>OA Challenge Configuration</h3>
    <span class="spacer"></span>
    <button mat-icon-button color="primary" (click)="helpEnabled = !helpEnabled"><mat-icon>help</mat-icon></button>
</div>
<div mat-dialog-content>
    
<form [formGroup]="fgConfig" autocomplete="off">
<ng-container formArrayName="rows">
    <mat-table [dataSource]="dataSource" class="gea-mat-table" style="padding-right: 5px; padding-left: 5px;">

        <ng-container matColumnDef="StartDate">
            <mat-header-cell *matHeaderCellDef>StartDate<br>(MM/DD/YYYY)</mat-header-cell>
            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                <span 
                    [class.hidden]="( (fgConfig.get('rows').value[i].isEditing && !isDateInPast(fgConfig.get('rows').value[i].StartDate)) ) && !fgConfig.get('rows').value[i].isDeleted"
                    [class.deleted]="fgConfig.get('rows').value[i].isDeleted">
                {{fgConfig.get('rows').value[i].StartDate}}
                </span>
                <mat-form-field [class.hidden]="!fgConfig.get('rows').value[i].isEditing || fgConfig.get('rows').value[i].isDeleted || isDateInPast(fgConfig.get('rows').value[i].StartDate)" appearance="fill" [style.width.px]="160">
                    <input matInput type="text" 
                           formControlName="StartDate"
                           (blur)="formatDate(configRows.controls[i].get('StartDate'))"/>
                    <mat-error *ngIf="configRows.controls[i].get('StartDate').errors?.required">StartDate required</mat-error>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="EndDate">
            <mat-header-cell *matHeaderCellDef>EndDate<br>(MM/DD/YYYY)</mat-header-cell>
            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                <span 
                    [class.hidden]="fgConfig.get('rows').value[i].isEditing && !fgConfig.get('rows').value[i].isDeleted"
                    [class.deleted]="fgConfig.get('rows').value[i].isDeleted">
                    {{fgConfig.get('rows').value[i].EndDate}}
                </span>
                <mat-form-field [class.hidden]="!fgConfig.get('rows').value[i].isEditing || fgConfig.get('rows').value[i].isDeleted" appearance="fill" [style.width.px]="160">
                    <input matInput type="text" 
                           formControlName="EndDate"
                           (blur)="formatDate(configRows.controls[i].get('EndDate'))" />
                    <mat-error *ngIf="configRows.controls[i].get('EndDate').errors?.required">EndDate required</mat-error>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Challenge">
            <mat-header-cell *matHeaderCellDef>OA Challenge</mat-header-cell>
            <mat-cell *matCellDef="let d; let i = index" [formGroup]="d">
                <span 
                    [class.hidden]="fgConfig.get('rows').value[i].isEditing && !fgConfig.get('rows').value[i].isDeleted"
                    [class.deleted]="fgConfig.get('rows').value[i].isDeleted">
                    {{fgConfig.get('rows').value[i].Challenge}}
                </span>
                <mat-form-field [class.hidden]="!fgConfig.get('rows').value[i].isEditing || fgConfig.get('rows').value[i].isDeleted" appearance="fill" [style.width.px]="100">
                    <input matInput type="text"
                           formControlName="Challenge"  
                           maxlength="80"/>
                    <mat-error *ngIf="configRows.controls[i].get('Challenge').errors?.numericValidator">Numeric Value</mat-error>
                    <mat-error *ngIf="configRows.controls[i].get('Challenge').errors?.required">OA Challenge required</mat-error>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let d; let i = index">
                <button *ngIf="!isDateInPast(fgConfig.get('rows').value[i].StartDate, fgConfig.get('rows').value[i].EndDate) && !fgConfig.get('rows').value[i].isDeleted && !fgConfig.get('rows').value[i].isEditing" 
                         mat-button 
                         color="primary" 
                         (click)="editLine(fgConfig,i)">
                    <mat-icon>create</mat-icon>Edit
                </button>
                
                <span *ngIf="fgConfig.get('rows').value[i].id == 0" style="min-width: 65.9px; max-width: 65.9px;"></span> <!-- Space element for when adding new to line up Delete button with other delete buttons -->

                <button *ngIf="!isDateInPast(fgConfig.get('rows').value[i].StartDate) && !fgConfig.get('rows').value[i].isDeleted && !fgConfig.get('rows').value[i].isEditing || fgConfig.get('rows').value[i].id == 0" 
                         mat-button color="warn" 
                         (click)="delete(fgConfig,i)">
                    <mat-icon>delete_forever</mat-icon>Delete
                </button>

                <button *ngIf="(fgConfig.get('rows').value[i].isEditing || fgConfig.get('rows').value[i].isDeleted) && fgConfig.get('rows').value[i].id != 0" 
                        mat-button 
                        color="primary" 
                        (click)="undo(fgConfig, i)">
                    <mat-icon>undo</mat-icon>
                    <span *ngIf="!fgConfig.get('rows').value[i].isDeleted">Undo - Edit</span>
                    <span *ngIf="fgConfig.get('rows').value[i].isDeleted">Undo - Delete</span>
                </button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>      
    </mat-table>
    <div>
        <button mat-button color="primary" (click)="add(fgConfig)"><mat-icon>add_circle</mat-icon>Add New</button>
    </div>
</ng-container>
</form>
</div>
<div [style]="{'color': 'red', 'font-weight': 'bold', 'padding-bottom': '20px'}">
	<ng-container *ngIf="startDateEQendDate; else codn2">
        StartDate or EndDate of a record cannot overlap with StartDate or EndDate of another record. Please correct them before saving.
    </ng-container>
    <ng-template #codn2>
        <ng-container *ngIf="startDateGTendDate; else codn3">
            StartDate greater than EndDate. Please correct them before saving.
        </ng-container>
      </ng-template>
      <ng-template #codn3>
        <ng-container *ngIf="overlappingDates; else codn4">
            StartDate already in Available time range. Please correct before saving.
        </ng-container>
      </ng-template>
      <ng-template #codn4>
        <ng-container *ngIf="multipleEndDateBlank; else codn5">
            Multiple records has EndDate blank, Please Update EndDate for a record.
        </ng-container>
      </ng-template>
    <ng-template #codn5>
        <div *ngIf="invalidFutureTimerangeExists">Please Update EndDate for a record because future record exists.</div>
    </ng-template>     
</div>

<div mat-dialog-actions>
    <button mat-raised-button [disabled]="!fgConfig.dirty || !fgConfig.valid" color="primary" (click)="save()">Save and Close</button>
    <span class="spacer"></span>
    <button mat-raised-button (click)="close()">Cancel</button>
</div>

<!-- Help Panel-->
<div *ngIf="helpEnabled" class="help" (click)="helpEnabled = !helpEnabled">
    <div class="help-content" (click)="$event.stopPropagation()">
        <h1>Help - OA Challenge Configuration</h1>
        <div>
            <p>
                OA Challenge is the percentage of OA Target to acheive.
            </p>

            <h2>Configuration</h2>
            
            <h3>Challenge, StartDate and EndDate</h3> 
            <p>
                Input the OA Challenge and the effective time range (StartDate, EndDate).
            </p>
    
        </div>
        <button mat-raised-button color="primary" (click)="helpEnabled = !helpEnabled">Close</button>
    </div>
</div>